export const THERAPIST_FFS_EVENTS = [
  {
    name: "Geetanjali",
    url: "https://calendly.com/d/cnbb-s64-djj/free-therapy-session-with-geetanjali",
  },
  {
    name: "Meera",
    url: "https://calendly.com/d/cntq-pzt-jbn/free-therapy-session-with-meera",
  },
  {
    name: "Mariam",
    url: "https://calendly.com/d/cnxs-79d-rvr/free-therapy-session-with-mariam",
  },
  {
    name: "Any",
    url: "https://calendly.com/d/crws-scd-7h6/free-therapy-session",
  },
];
